import { render, staticRenderFns } from "./_RecycleManifest.vue?vue&type=template&id=2c290dcd&scoped=true&"
import script from "./_RecycleManifest.vue?vue&type=script&lang=js&"
export * from "./_RecycleManifest.vue?vue&type=script&lang=js&"
import style0 from "./_RecycleManifest.vue?vue&type=style&index=0&id=2c290dcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c290dcd",
  null
  
)

export default component.exports